import React from 'react'
import PropTypes from 'prop-types'
import TitleBar from '../Layout/titleBar'
import { Row, Col } from 'react-flexbox-grid'
import Paper from '@material-ui/core/Paper'
import TextField from '@material-ui/core/TextField'

import CurrencyFormat from 'react-currency-format'
import './styles.css'


class PromoEdit extends React.Component {

    render() {
        
        return (
            <div className='crearEditarUsuario'>

                {/* menú superior */}
                <TitleBar 
                    title={ ((this.props.promocion.id===undefined)?'Nueva':'Editar') +' promoción '} 
                    type='createArticulo'  /** tiene guardar y cancelar */
                    handleOnSave={this.props.handleOnSave} 
                    handleOnBack={this.props.handleOnCancel} 
                    showSearch = {false}
                />
                
                <Paper className='myBox no-margin'>
                    <Row>
                        <Col md={6}>
                            <TextField className='myInput'        
                                label='Nombre'
                                name='nombre'
                                fullWidth
                                required
                                error={this.props.error && this.props.error.nombre}
                                helperText={(this.props.error && this.props.error.nombre)?this.props.error.nombre:""}
                                value={this.props.promocion.nombre}
                                onChange={this.props.handleOnChange}
                            />                            
                        </Col>
                        <Col md={6}>
                            <CurrencyFormat className='currencyInput'           
                                label='Porcentaje de descuento'
                                fullWidth
                                required
                                error={this.props.error && this.props.error.porcentajeDescuento}
                                helperText={(this.props.error && this.props.error.porcentajeDescuento)?this.props.error.porcentajeDescuento:""}
                                name='porcentajeDescuento'
                                value={this.props.promocion.porcentajeDescuento}
                                onChange={this.props.handleOnChange}
                                
                                customInput={TextField}  
                                decimalScale={2} 
                                fixedDecimalScale={true} 
                                allowNegative= {false} 
                                decimalSeparator="," 
                                thousandSeparator="."
                                suffix={'%'} 
                            />
                        </Col>                        
                        <Col md={6}>
                        </Col>
                    </Row>

                    <Row>
                        <Col md={6}>
                            <CurrencyFormat className='currencyInput'         
                                label='Límite inferior'
                                fullWidth
                                required
                                error={this.props.error && this.props.error.limiteInferior}
                                helperText={(this.props.error && this.props.error.limiteInferior)?this.props.error.limiteInferior:""}
                                name='limiteInferior'
                                value={this.props.promocion.limiteInferior}
                                onChange={this.props.handleOnChange}
                                 
                                customInput={TextField}  
                                decimalScale={2} 
                                fixedDecimalScale={true} 
                                allowNegative= {false} 
                                decimalSeparator="," 
                                thousandSeparator="." 
                                prefix={'$'} 
                            />
                        </Col>
                        
                        <Col md={6}>
                            <CurrencyFormat 
                                className='currencyInput'      
                                label='Límite superior'
                                fullWidth
                                
                                error={this.props.error && this.props.error.limiteSuperior}
                                helperText={(this.props.error && this.props.error.limiteSuperior)?this.props.error.limiteSuperior:""}
                                name='limiteSuperior'
                                value={this.props.promocion.limiteSuperior}
                                onChange={this.props.handleOnChange}
                                 
                                customInput={TextField}  
                                decimalScale={2} 
                                fixedDecimalScale={true} 
                                allowNegative= {false} 
                                decimalSeparator="," 
                                thousandSeparator="." 
                                prefix={'$'} 
                            />
                        </Col>
                    </Row>

                </Paper>
                
                
            </div>
        )
    }
}

PromoEdit.propTypes = {
    promocion: PropTypes.object.isRequired,
    handleOnChange: PropTypes.func.isRequired,
    handleOnSave: PropTypes.func.isRequired,   
    handleOnCancel : PropTypes.func.isRequired
}


export default PromoEdit